const translations = {
  title: "Melt Account",
  subtitle: "Track scrap and dust melting jobs, recovery, and metal loss.",
  newMelt: "New Melt Job",
  meltNo: "Melt No.",
  meltDate: "Date",
  // Fields
  inputType: "Input Type",
  input_scrap: "Scrap Gold",
  input_dust: "Dust / Sweepings",
  input_mixed: "Mixed",
  inputWeight: "Input Weight (g)",
  inputPurity: "Input Purity",
  inputFineMg: "Fine Gold Input (mg)",
  recoveryWeight: "Recovery Weight (g)",
  recoveryPurity: "Recovery Purity",
  recoveryFineMg: "Fine Gold Recovered (mg)",
  meltLoss: "Melt Loss (mg)",
  lossPercent: "Loss %",
  notes: "Notes",
  // Status
  status_pending: "Pending",
  status_in_progress: "In Progress",
  status_completed: "Completed",
  // Actions
  createMelt: "Create Melt Job",
  recordRecovery: "Record Recovery",
  closeMelt: "Close Melt Job",
  printReport: "Print Report",
  // Summary
  totalInput: "Total Input",
  totalRecovery: "Total Recovery",
  totalLoss: "Total Loss",
  avgRecovery: "Avg. Recovery %",
  // Empty states
  noMeltJobs: "No melt jobs yet.",
  createFirst: "Create the first melt job.",
  // Columns
  col_meltNo: "Melt No.",
  col_date: "Date",
  col_input: "Input",
  col_recovery: "Recovery",
  col_loss: "Loss",
  col_status: "Status",
  col_action: "Action",
};

export default translations;
